import { render } from "./GuideOverlay.vue?vue&type=template&id=a8ac898c"
import script from "./GuideOverlay.vue?vue&type=script&lang=js"
export * from "./GuideOverlay.vue?vue&type=script&lang=js"

import "./GuideOverlay.vue?vue&type=style&index=0&id=a8ac898c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__